import type { WorkspaceStats } from '../../../lib/outreach/types'
import { CapSection } from './CapSection'
import { KpiTiles } from './KpiTiles'
import { PipelineSection } from './PipelineSection'
import { StatTables } from './StatTables'

export function BusinessView({ stats, days }: { stats: WorkspaceStats; days: number }) {
  return (
    <>
      <KpiTiles totals={stats.totals} days={days} />
      <CapSection programs={stats.by_program} />
      <StatTables
        programs={stats.by_program}
        sites={stats.by_site}
        mailboxes={stats.by_mailbox}
        days={days}
      />
      <PipelineSection stats={stats} />
    </>
  )
}
